/** PathIN 对外联系信息（单处维护，供 Footer、联系页等复用） */
export const PATHIN_CONTACT_EMAIL = 'pathin@pathin.eu'

export const PATHIN_SOCIAL_URLS = {
  xiaohongshu: 'https://www.xiaohongshu.com/user/profile/673e18a3000000001c0198c0',
  instagram: 'https://www.instagram.com/pathin.official/',
} as const

export const PATHIN_WECHAT_ID = 'PathIN-Berlin'

export const PATHIN_POSTAL_ADDRESS = {
  street: 'Arabellastraße 5',
  city: '81925 München',
  country: 'Germany',
} as const
